export enum ETipoUnidadSUNAT {
  BOBINAS = '4A',
  BALDE = 'BJ',
  BARRILES = 'BLL',
  BOLSA = 'BG',
  BOTELLAS = 'BO',
  CAJA = 'BX',
  CARTONES = 'CT',
  CENTIMETRO_CUADRADO = 'CMK',
  CENTIMETRO_CUBICO = 'CMQ',
  CENTIMETRO_LINEAL = 'CMT',
  CIENTO_DE_UNIDADES = 'CEN',
  CILINDRO = 'CY',
  CONOS = 'CJ',
  DOCENA = 'DZN',
  DOCENA_POR_10 = 'DZP',
  FARDO = 'BE',
  GALON_INGLES = 'GLI',
  GRAMO = 'GRM',
  GRUESA = 'GRO',
  HECTOLITRO = 'HLT',
  HOJA = 'LEF',
  JUEGO = 'SET',
  KILOGRAMO = 'KGM',
  KILOMETRO = 'KTM',
  KILOVATIO_HORA = 'KWH',
  KIT = 'KT',
  LATAS = 'CA',
  LIBRAS = 'LBR',
  LITRO = 'LTR',
  MEGAWATT_HORA = 'MWH',
  METRO = 'MTR',
  METRO_CUADRADO = 'MTK',
  METRO_CUBICO = 'MTQ',
  MILIGRAMOS = 'MGM',
  MILILITRO = 'MLT',
  MILIMETRO = 'MMT',
  MILIMETRO_CUADRADO = 'MMK',
  MILIMETRO_CUBICO = 'MMQ',
  MILLARES = 'MLL',
  MILLON_DE_UNIDADES = 'UM',
  ONZAS = 'ONZ',
  PALETAS = 'PF',
  PAQUETE = 'PK',
  PAR = 'PR',
  PIES = 'FOT',
  PIES_CUADRADOS = 'FTK',
  PIES_CUBICOS = 'FTQ',
  PIEZAS = 'C62',
  PLACAS = 'PG',
  PLIEGO = 'ST',
  PULGADAS = 'INH',
  RESMA = 'RM',
  TAMBOR = 'DR',
  TONELADA_CORTA = 'STN',
  TONELADA_LARGA = 'LTN',
  TONELADAS = 'TNE',
  TUBOS = 'TU',
  UNIDAD_BIENES = 'NIU',
  UNIDAD_SERVICIOS = 'ZZ',
  US_GALON_3L = 'GLL',
  YARDA = 'YRD',
  YARDA_CUADRADA = 'YDK',
}
